import {
  GETVIEWWALLETOWNERBANKDETAILS_SUCCESS,
  GETVIEWWALLETOWNERBANKDETAILS_FAILED,
  RESET_GETVIEWWALLETOWNERBANKDETAILS,
  LOADING_GETVIEWWALLETOWNERBANKDETAILS,
  NETWORK_ERROR_GETVIEWWALLETOWNERBANKDETAILS,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETVIEWWALLETOWNERBANKDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETVIEWWALLETOWNERBANKDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETVIEWWALLETOWNERBANKDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETVIEWWALLETOWNERBANKDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETVIEWWALLETOWNERBANKDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
